import Box from "@mui/material/Box"
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress"
import { styled } from "@mui/material/styles"
import PropTypes from "prop-types"

const PurpleLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 4,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.colors.pink,
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: theme.palette.colors.purple,
  },
}))

export default function ConditionalPurpleLinearProgress({ visible }) {
  if (visible) {
    return <PurpleLinearProgress />
  }
  return <Box sx={{ height: 4, background: "transparent" }} />
}

ConditionalPurpleLinearProgress.propTypes = {
  visible: PropTypes.bool,
}
